import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import Editcompanymodal from "./editcompanymodal";
import Loanbackmodal from "./loanbackmodal";
import money_rounding from "../../utils/money_rounding";
import { useNavigate } from 'react-router-dom';

const Companylist = () => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const navigate = useNavigate();

  const [company_id, setcompany_id] = useState();
  const [company_name, setcompany_name] = useState();
  const [company_address, setcompany_address] = useState();
  const [company_phone, setcompany_phone] = useState();
  const [show, setshow] = useState(false);
  const [show1, setshow1] = useState(false);
  return (
    <div>
      <Editcompanymodal
        show={show}
        setshow={setshow}
        company_id={company_id}
        company_name={company_name}
        setcompany_name={setcompany_name}
        company_address={company_address}
        setcompany_address={setcompany_address}
        company_phone={company_phone}
        setcompany_phone={setcompany_phone}
      />
      <Loanbackmodal show={show1} setshow={setshow1} company_id={company_id} />
      {/* Company List Card */}
      <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
        {/* Section Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h2 className="text-base font-semibold text-slate-800">لیستی کۆمپانیا</h2>
        </div>

        {/* Table */}
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-100">
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                ناوی کۆمپانیا
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                ناونیشان
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                ژمارەی تەلەفۆن
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                قەرزی کۆمپانیا
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                گێڕانەوەی قەرز
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                گۆڕانکاری
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {initState.company.map((lis) => (
              <tr key={lis.company_id} className="hover:bg-slate-50 transition-colors duration-100">
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  <p className={"text-indigo-600 whitespace-nowrap underline cursor-pointer"}
                     onClick={() =>{
                        initDispatch({type:'setcompany_ledger', payload:{ledger_company_id:lis.company_id, ledger_company_name:lis.company_name}});
                        navigate('/company/ledger');
                     }}
                  >
                    {lis.company_name}
                  </p>
                </td>
                <td className="px-6 py-4 text-sm text-slate-500 text-right">
                    {lis.company_address}
                </td>
                <td className="px-6 py-4 text-sm text-slate-500 text-right">
                    {lis.company_phone}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-700 text-right">
                    {numberbeautify(money_rounding(lis.company_loan))+" IQD"}
                </td>
                <td className="px-6 py-4 text-right">
                  <button
                    className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200 transition-colors cursor-pointer"
                    onClick={() => {
                      setcompany_id(lis.company_id);
                      setshow1(true);
                    }}
                  >
                    گێڕانەوەی قەرز
                  </button>
                </td>
                <td className="px-6 py-4 text-right">
                  <button
                    className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                    onClick={() => {
                      setcompany_id(lis.company_id);
                      setcompany_name(lis.company_name);
                      setcompany_address(lis.company_address);
                      setcompany_phone(lis.company_phone);
                      setshow(true);
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Companylist;
